<template>
  <div class="column-small">
    <small class="title-small">{{row[column.small]}} {{row[column.tipo]}}</small>
    <span class="title">{{row[column.field]}}</span>
  </div>
</template>

<script>
export default {
  name: 'Small',
  props: ['column', 'row']
}
</script>
